module.exports = __webpack_public_path__ + "img/exit_9.cb9b8c5b.svg";